import React from 'react'
import { Dialog, Pane, Strong, Table, Text } from 'evergreen-ui'
import { connect } from 'react-redux'
import { getFormattedTime } from '../util'

const BulkBookingSlotsAvailabilityDialog = props => {
  const {
    isShown,
    showDialog,
    verifySlotsAvailabilityData,
    cartBulkBookingSlots
  } = props

  let availableSlots, unavailableSlots
  if (
    verifySlotsAvailabilityData &&
    verifySlotsAvailabilityData.requestStatus === 1
  ) {
    availableSlots = verifySlotsAvailabilityData.data['availableSlots']
    unavailableSlots = verifySlotsAvailabilityData.data['bookedSlots'].concat(
      verifySlotsAvailabilityData.data['blockedSlots']
    )
  }

  return (
    <React.Fragment>
      {verifySlotsAvailabilityData && isShown && (
        <Dialog
          isShown={isShown}
          title={
            unavailableSlots.length
              ? 'Following slots are not available for booking.'
              : availableSlots.length === 0
              ? 'No slots Available'
              : 'All the slots are available for booking.'
          }
          onCloseComplete={() => showDialog(false)}
          onConfirm={cartBulkBookingSlots}
          hasFooter={availableSlots.length !== 0}
        >
          <Pane
            border={'default'}
            background={'tint1'}
            padding={10}
            marginBottom={10}
          >
            <Pane display={'flex'} justifyContent={'space-between'}>
              <Strong>Total Slots</Strong>
              <Strong>{availableSlots.length + unavailableSlots.length}</Strong>
            </Pane>
            <Pane display={'flex'} justifyContent={'space-between'}>
              <Strong>Available Slots</Strong>
              <Strong>{availableSlots.length}</Strong>
            </Pane>
            <Pane display={'flex'} justifyContent={'space-between'}>
              <Strong>Unavailable Slots</Strong>
              <Strong>{unavailableSlots.length}</Strong>
            </Pane>
          </Pane>
          {unavailableSlots.length ? (
            <React.Fragment>
              <Strong marginTop={10}>Unavailable Slots</Strong>
              <Table marginTop={10} border={'default'}>
                <Table.Head>
                  <Table.TextHeaderCell>Date</Table.TextHeaderCell>
                  <Table.TextHeaderCell>Time</Table.TextHeaderCell>
                  <Table.TextHeaderCell>Court</Table.TextHeaderCell>
                </Table.Head>
                <Table.Body>
                  {unavailableSlots.map(slot => (
                    <Table.Row>
                      <Table.TextCell>{formatDate(slot['slotDate'])}</Table.TextCell>
                      <Table.TextCell>
                        {getFormattedTime(slot['slotTime'])}
                      </Table.TextCell>
                      <Table.TextCell>{slot['courtName']}</Table.TextCell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </React.Fragment>
          ) : (
            <React.Fragment />
          )}
          <Pane marginTop={20} display={'flex'} justifyContent={'center'}>
            <Text fontSize={10} color={'muted'}>
              <em>
                {unavailableSlots.length
                  ? 'Only the available slots in the pattern will be booked.'
                  : availableSlots.length === 0
                  ? ''
                  : 'All the slots in the pattern will be booked.'}
              </em>
            </Text>
          </Pane>
        </Dialog>
      )}
    </React.Fragment>
  )
}

const formatDate = (dateString) => {
  // Convert the string to a Date object
  const dateObject = new Date(dateString);

  // Extract the day, month, and year
  const day = String(dateObject.getDate()).padStart(2, '0');
  const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = dateObject.getFullYear();

  // Format the date to 'dd-mm-yyyy'
  return `${day}-${month}-${year}`;
};

const mapStateToProps = ({ verifySlotsAvailabilityData }) => ({
  verifySlotsAvailabilityData
})

export default connect(mapStateToProps)(BulkBookingSlotsAvailabilityDialog)
